<template>
	<el-tag v-if="type == counterpartyType.Consumer" size="small" type="success" effect="plain">Заказчик</el-tag>
	<el-tag v-if="type == counterpartyType.Contractor" size="small" type="warning" effect="plain">Подрядчик</el-tag>
    <el-tag v-if="type == counterpartyType.Supplier" size="small" type="primary" effect="plain">Поставщик</el-tag>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { ElTag } from 'element-plus';
import CounterpartyType from '@/models/enums/CounterpartyType';

@Options({	
	components: {
		ElTag
	},
	props: {
		type: Number
	}
})
export default class CounterpartyTypeComponent extends Vue {
	/** props */
	type!: Number;

	/** constants */
	counterpartyType = CounterpartyType;

	/** Потребитель/Заказчик */
	//Consumer = 1
	/** Поставщик */
	//Supplier = 2
	/** Подрядчик */
	//Contractor = 3
}
</script>